import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Image from "../../../components/image";
import Blog from "../../../components/blogFooter/blogFooter";
import { asset } from "../../../helpers/dom.helper";
import { ContentWrapper } from "../../../layouts";
import { Media, MediaContextProvider } from "../../../media";
import BgWithText from '../../../components/backgroundWithText/BgWithText';
import styles from './svmVsLivingOs.module.scss';

import Guarantee from "../../Home/guaranteeHome";
import { toRoute } from "../../../i18n";

export default function SvmVsLivingOs() {

  const { t, i18n } = useTranslation(['translation', 'svmVsLivingOs'])

  if (!i18n.isInitialized) {
    return null;
  }

  return (
    <>
      <Helmet>
        <title>{t("svmVsLivingOs:blogName")} | Silverman</title>
        <meta name="description" content={t("svmVsLivingOs:metaDescription")} />
        <meta name="keywords" content="livingos" />
        <link rel="canonical" href="https://silverman.app/silverman-vs-the-livingos" />
      </Helmet>

      <div className={styles.svmVsLivingOs}>
        <MediaContextProvider>
            <Media lessThan="md">
                <BgWithText
                data={{
                    subtitle: t('svmVsLivingOs:blogName')
                }}
                image={asset('/images/settingUpJuristic/main.jpg')}
                height={300}
                // noBGPosition={true}
                />
            </Media>
            <Media greaterThanOrEqual="md">
                <BgWithText
                data={{
                    subtitle: t('svmVsLivingOs:blogName')
                }}
                image={asset('/images/settingUpJuristic/main.jpg')}
                height={350}
                noBGPosition={true}
                />
            </Media> 
            {/* end banner */}


            <ContentWrapper className="py-5 main-ai-facial">
            <div style={{ maxWidth: '1100px', margin: 'auto' }}>
                <h2 className="mb-4 font-weight-400 text-center">{t('svmVsLivingOs:blogName') }</h2>
                <div className="row">
                <div className="col-12 col-sm-6 pr-sm-0">
                    <div className="mt-4">
                        <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs01.webp')} />                    
                    </div>
                </div>
                <div className="col-12 col-sm-6 pl-sm-0">
                    <div>                  
                        <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:If you're looking for an efficient juristic management system") }} />
                    </div>
                </div>
                </div>
                
                <div className="mt-4">              
                <h3 className="mt-5 mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Get to Know The LivingOS') }</h3> 
                <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs02.webp')} />
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:The Livingos Corporation Co., Ltd., is a seasoned expert in providing juristic person applications") }} />
                
                <h3 className="mt-5 mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Silverman’s greater completeness and value compared to The LivingOS') }</h3> 
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:It’s undeniable that The LivingOS is a top-tier choice for juristic management companies") }} />


                <div className="row mt-5">
                    <div className="col-12 col-sm-6 pr-sm-0">
                        <div>
                            <Media lessThan="md">
                                <h3 className="mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Data Security System') }</h3> 
                            </Media>
                            <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs03.webp')} />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 pl-sm-0">
                        <div>         
                            <Media greaterThanOrEqual="md">                            
                                <h3 className="mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Data Security System') }</h3> 
                            </Media>                                 
                            <p className="mb-4 font-weight-400" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Data security is a critical priority for juristic management companies") }} />
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-12 col-sm-6 pr-sm-0">
                        <div>
                            <h3 className="mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Technology and User Convenience') }</h3> 
                            <Media greaterThanOrEqual="md">
                                <p className="mb-4 font-weight-400" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Silverman utilizes cutting-edge technology and software") }} />
                            </Media>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 pl-sm-5 pt-0">
                        <div>                                                                  
                            <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs04.webp')} />
                            <Media lessThan="md">
                                <p className="mb-4 font-weight-400" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Silverman utilizes cutting-edge technology and software") }} />
                            </Media>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-12 col-sm-6 pr-sm-0">
                        <div>
                            <Media lessThan="md">                                
                                <h3 className="mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Project Information and Registration Records') }</h3>                         
                            </Media>
                            <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs05.webp')} />
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 pl-sm-0">
                        <div>                                
                            <Media greaterThanOrEqual="md"> 
                                <h3 className="mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Project Information and Registration Records') }</h3>                         
                            </Media>                                                                
                            <p className="mb-4 font-weight-400" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:In addition to recording various") }} />
                        </div>
                    </div>
                </div>
                
                <div className="row mt-5">
                    <div className="col-12 col-sm-6 pr-sm-0">
                        <div>
                            <h3 className="mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Dashboard System') }</h3>                         
                            <Media greaterThanOrEqual="md">
                                <p className="mb-4 font-weight-400" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Silverman’s system provides an overview of each feature") }} />
                            </Media>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 pl-sm-5 pt-0">
                        <div>                                                                                          
                            <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs06.webp')} />
                            <Media lessThan="md">
                                <p className="mb-4 font-weight-400" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Silverman’s system provides an overview of each feature") }} />
                            </Media>
                        </div>
                    </div>
                </div>

                <h3 className="mt-5 mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Various Management Systems') }</h3> 
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:The management system is as important as other parts") }} />
                <ul className="ml-5">
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:News announcements can be sent via the app") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:There is a chat system for complaints with an option to enable or disable auto-reply") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:The maintenance work system is comprehensive") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:New parcel notifications are sent through the app") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Surveys can be conducted through the app") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Residents can contact emergency numbers") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Central facility booking services allow setting conditions") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Compensation claims can be submitted via the app") }} />
                </ul>

                <h3 className="mt-5 mb-3 font-weight-400 text-center">{t('svmVsLivingOs:Accounting Management System') }</h3> 
                <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs07.webp')} />
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:The accounting management system is one of the most frequently praised features") }} />
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Most importantly, Silverman offers exceptional value to its customers") }} />
                <p className="mb-3 ml-4 font-weight-400 text-left"><b>1. {t('svmVsLivingOs:Accounts Receivable System') }</b></p> 
                <ul className="ml-5">
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Issuing all types of invoices") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Credit note issuance allows creating multiple credit entries simultaneously") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Payment receipt options include full payment") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Advance payments and security deposits can be received") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Receipt issuance features a system that prevents any modifications") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Creating and clearing advance expense entries") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Automatic fine calculation based on percentage or daily rates, with automatic computation") }} />
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Issuing important documents such as suspension and withdrawal letters") }} />
                </ul>

                <p className="mb-3 ml-4 font-weight-400 text-left"><b>2. {t('svmVsLivingOs:Accounts Payable System') }</b></p> 
                <p className="mb-3 ml-4 font-weight-400 text-left">{t('svmVsLivingOs:Comprehensively manages all aspects') }</p> 
                
                <p className="mb-3 ml-4 font-weight-400 text-left"><b>3. {t('svmVsLivingOs:Accounting System') }</b></p> 
                <p className="mb-3 ml-4 font-weight-400 text-left">{t('svmVsLivingOs:Comprehensive Accounting Management') }</p> 

                <p className="mb-3 ml-4 font-weight-400 text-left"><b>4. {t('svmVsLivingOs:Comprehensive Reporting') }</b></p> 
                <p className="mb-3 ml-4 font-weight-400 text-left">{t('svmVsLivingOs:With Silverman, a comprehensive corporate management application') }</p> 

                <p className="mb-3 ml-4 font-weight-400 text-left"><b>5. {t('svmVsLivingOs:Additional Services') }</b></p>               
                <p className="mb-3 font-weight-400 ml-4 text-left" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:In addition to the standard features") }} />

                <p className="mb-3 ml-4 font-weight-400 text-left"><b>6. {t('svmVsLivingOs:After-sales Support Team') }</b></p> 
                <p className="mb-3 font-weight-400 ml-4 text-left" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:You don’t need to worry about any operational issues") }} />
                
                <h3 className="mt-5 mb-3 font-weight-400 text-center">{t('svmVsLivingOs:A conclusion that indicates using Silverman is more valuable and comprehensive than anyone else') }</h3> 
                <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs08.webp')} />
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Based on all the details outlined regarding the features of the Silverman") }} />

                <ul className="ml-5">
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:The Silverman App can easily") }} />              
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:It can connect with intelligent barrier") }} />              
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Silverman offers an E-Debt Collection") }} />              
                    <li className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:Our entire team is ready to provide professional") }} />                     
                </ul>
                <Image src={asset('/images/blogImage/svmVsLivingOs/svmVsLivingOs09.webp')} />
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:For those wondering if The LivingOS is good") }} />
                <p className="mb-4 font-weight-400 mt-4" dangerouslySetInnerHTML={{ __html: t("svmVsLivingOs:If you’re interested in having us support your business") }} />

                </div>          



            </div>


            <h5 className="mb-2 font-weight-400 text-center pt-5"
                dangerouslySetInnerHTML={{ __html: t('svmVsLivingOs:contact-detail') }} />
            <div className="text-center keycard-regis">
                <button type="submit" className="btn btn-primary py-2 btn-register" style={{ color: '#ffffff' }}>
                <Link to={toRoute("/register")}>
                    {t("svmVsLivingOs:Free Consult")}
                </Link>
                </button>
            </div>
            </ContentWrapper>
        </MediaContextProvider>

        <br></br><br></br>
        <Guarantee />
        <br></br><br></br>

        <Blog />
      </div>
    </>

  )

}
